import { CSSProperties, useRef } from "react";
import { useHover } from "frontend/ui-components/floaters/use-hover";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";
import { getMenuItemIdSelector, MenuItem as SideMenuItem } from "./side-menu-items";

export function MenuItemCIM({
  item,
  onItemClick,
  highlight,
  style,
}: {
  item: SideMenuItem;
  onItemClick: (item: SideMenuItem, ref: any) => void;
  highlight: boolean;
  setShowSidePanel: (enable: boolean) => void;
  style?: CSSProperties;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const hover = useHover(ref);

  const onClick = item.available ? () => onItemClick(item, ref) : undefined;

  if (item.hidden) {
    return null;
  }
  return (
    <>
      <div
        key={item.type}
        style={
          {
            ...style,
            height: "100%",
            display: "grid",
            placeContent: "center",
            cursor: "pointer",
          } as CSSProperties
        }
        ref={ref}
        onClick={onClick}
        data-testid={item.tooltip}
        id={getMenuItemIdSelector(item.type)}
      >
        {item.iconRenderer(highlight)}
        {hover && item.tooltip && (
          <Tooltip side={"top"} label={item.tooltip} relativeTo={ref} boundary="none" design={"monday"} />
        )}
      </div>
    </>
  );
}
